import React from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import details from "../../../../../assets/images/icons/tables/details.svg"
import { FaCheck } from "react-icons/fa6";
import { RiCloseLargeFill } from "react-icons/ri";
import Pagination from '../../../../shared/pagination';
import date from "../../../../../assets/images/icons/tables/date.svg"
import download from "../../../../../assets/images/icons/tables/download.svg"
import whatsappIcon from "../../../../../assets/images/icons/tables/whatsapp.svg"
import { useNavigate } from 'react-router-dom';
import ContentLoader from 'react-content-loader';

const DynamicTable = ({
    data,
    config,
    showRadioButtons = false,
    selectedRows = [],
    onCheckboxChange,
    currentPage,
    totalPages,
    changePage,
    recordsPerPage,
    totalRecords,
    showPagination = true,
    collapsed = false,
    statusColors ={},
    liberationStatusColors = {},
    generalStatusColors = {},
    scrollToTop,
    loading = false,
    isOCProvider = false,
    onSelectAll,
    allSelected,
    activeTab = '',
    headerStyle,
    headerFont = "font-itcbold",
    confirmedPositions = [],
    refusedPositions = [],
    onAppointmentAction = () => {}
 }) => {
  const [downloadingIds, setDownloadingIds] = React.useState([]);
  const [loadingDetailsIds, setLoadingDetailsIds] = React.useState([]);

  const { headers, accessors, widths } = config;
  const navigate = useNavigate();
/*
  const handleContact = (positionId) => {
    navigate(`/compradores?positionId=${positionId}`);
  };
  */

  const handleDownload = async (purchaseOrderId, downloadFunction) => {
    setDownloadingIds(prev => [...prev, purchaseOrderId]);
    try {
      await downloadFunction();
    } finally {
      setDownloadingIds(prev => prev.filter(id => id !== purchaseOrderId));
    }
  };

  
  const handleViewDetails = async (purchaseOrderId, viewDetailsFunction) => {
    setLoadingDetailsIds(prev => [...prev, purchaseOrderId]);
    try {
      await viewDetailsFunction();
    } finally {
      setLoadingDetailsIds(prev => prev.filter(id => id !== purchaseOrderId));
    }
  };

const handleContact = (areaId) => {

  if (!areaId) {
    navigate("/compradores", { 
      state: { 
        shouldScroll: false 
      },
      replace: true
    });
    return;
  }

  navigate("/compradores", { 
    state: { 
      areaId, 
      shouldScroll: true 
    },
    replace: true
  });
};

const TableContentLoader = ({ rows = 5, columns = headers.length }) => {
  const rowHeight = 62;
  
  return (
    <ContentLoader 
      speed={2}
      width="100%"
      height={rows * rowHeight}
      viewBox={`0 0 100% ${rows * rowHeight}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      {Array(rows).fill('').map((_, rowIndex) => (
        headers.map((_, colIndex) => (
          <rect 
            key={`${rowIndex}-${colIndex}`}
            x={colIndex === 0 ? '0' : `calc(${widths.slice(0, colIndex).reduce((a, b) => a + parseFloat(b.replace('px', '')), 0)}px + ${colIndex * 10}px)`}
            y={rowIndex * rowHeight + 10}
            rx="4" 
            ry="4" 
            width={`${widths[colIndex]}`}
            height="20"
          />
        ))
      ))}
    </ContentLoader>
  );
};

  return (
    <>
      {loading ? (
        <div className="w-full p-4 bg-white">
          <TableContentLoader rows={recordsPerPage} columns={headers.length} />
        </div>
      ) : (
      <>
        {data.length === 0 ? (
          <div className="flex items-center justify-center w-full p-8 py-16 text-center">
            <p className="text-red font-itcmedium">No se encontraron registros.</p>
          </div>
        ) : (
        <SimpleBar className="max-w-full max-h-full table-simplebar scroll-container">
          <table className="w-full bg-white border border-collapse border-blue">
            <thead>
              <tr className={`text-[14px] 2xl:text-[16px] leading-tight text-center ${headerFont} `}>
                {headers.map((header, index) => (
                  <th 
                    key={index}
                    className={`p-3 border text-center ${headerStyle} border-[#D9D9D9]`}
                    style={{ minWidth: widths[index] }}
                  >
                    {header === '#' && showRadioButtons ? (
                      <div className="flex items-center justify-center">
                        <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={(e) => onSelectAll(e.target.checked)}
                          className="hidden peer"
                          id="select-all-checkbox"
                        />
                        <label 
                          htmlFor="select-all-checkbox" 
                          className="flex items-center justify-center w-5 h-5 rounded-full cursor-pointer bg-[#D9D9D9] border-blue peer-checked:bg-green-light peer-checked:border-transparent"
                        >
                          <span className="hidden w-3 h-3 rounded-full peer-checked:block"></span>
                        </label>
                      </div>
                    ) : header}
                  </th>
                ))}
              </tr>
            </thead>
            {!collapsed && (
            <tbody className='transition-all duration-300 ease-in-out'>
              {data.map((row, rowIndex) => (
                <tr 
                  key={rowIndex}
                  className={`text-[13px]  2xl:text-[15px] p-3 border-collapse h-[62px] font-itcmedium text-left
                    ${isOCProvider 
            ? (row.status?.active === false || (activeTab === 'Observaciones' && row.isViewed === false) )
                ? 'bg-blue/[0.1]' 
                : 'bg-white' 
                        : rowIndex % 2 === 0 
                            ? 'bg-white' 
                            : 'bg-[#EBEBEB]/[0.2]'
                    }`}
                  >
                    {accessors.map((accessor, colIndex) => {
                      if (accessor === 'id' && showRadioButtons) {
                        const isSelectable = row.canSchedule !== false;

                        return (
                          <td key={colIndex} className="p-3 border border-[#D9D9D9]">
                            <div className="flex items-center justify-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.includes(row.id)}
                                onChange={() => {
                                  if (isSelectable) {
                                    onCheckboxChange(row.id);
                                  } else {
                                  }
                                }}
                                className={`hidden peer ${!isSelectable ? 'opacity-50 cursor-not-allowed' : ''}`}
                                disabled={!isSelectable}
                                id={`checkbox-${row.id}`} 
                                title={!isSelectable ? row.scheduleReason : ''}
                              />
                              <label 
                                htmlFor={`checkbox-${row.id}`} 
                                className={`flex items-center justify-center w-5 h-5 rounded-full border-blue 
                                  ${isSelectable 
                                    ? `cursor-pointer ${selectedRows.includes(row.id) 
                                        ? 'bg-green-light border-transparent' 
                                        : 'bg-[#D9D9D9]'}`
                                    : 'bg-gray-100 cursor-not-allowed opacity-50 border-gray-400'
                                  }`}
                                  >
                                  <span className={`${selectedRows.includes(row.id) && isSelectable ? 'block' : 'hidden'} w-3 h-3 rounded-full`}></span>
                              </label>
                            </div>
                          </td>
                        );
                      }

                      if (accessor === 'id') {
                        return (
                          <td key={colIndex} className="p-3 text-center border border-[#D9D9D9]">
                            {row.displayId|| row.id}
                          </td>
                        );
                      }
                      return (
                        <td 
                          key={colIndex}
                          className="p-3 text-center border border-[#D9D9D9]"
                          >
                            {renderCell(
                              row[accessor],
                              accessor,
                              row,
                              onCheckboxChange,
                              selectedRows,
                              statusColors,
                              liberationStatusColors,
                              generalStatusColors,  handleContact,
                              downloadingIds,
                              handleDownload,
                              loadingDetailsIds,
                              handleViewDetails,
                              confirmedPositions,
                              refusedPositions,
                              onAppointmentAction
                              )}
                        </td>
                      );
                    })}
                </tr>
              ))}
                </tbody>
            )}

          </table>
        </SimpleBar>
        )}

        {showPagination && data.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            changePage={changePage}
            recordsPerPage={recordsPerPage}
            totalRecords={totalRecords}
          />
        )}
      </>
      )}
    </>
  );
};

const renderCell = (
  value,
  accessor,
  row,
  onCheckboxChange,
  selectedRows,
  statusColors,
  liberationStatusColors,
  generalStatusColors, handleContact,
  downloadingIds,
  handleDownload,
  loadingDetailsIds,
  handleViewDetails,
  confirmedPositions = [],
  refusedPositions = [],
  onAppointmentAction = () => {}
) => {

  if (typeof accessor === 'string' && accessor.includes('.')) {
    const keys = accessor.split('.');
    value = keys.reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : ''), row);
  }
  


  if (accessor === 'whatsapp') {
    return  <div className="flex items-center justify-center">
              <button
                onClick={() => {
                  if (typeof value === 'function') {
                    value(); 
                  }
                }}
                disabled={value === null}
                className={`p-2 flex justify-center items-center rounded-[4px] border border-[#D9D9D9] w-12 h-[37px] ${
                  value !== null ? 'bg-[#EFEEF7] cursor-pointer hover:bg-[#a5e49f] hover:border-[#a5e49f]' 
                                : ' hidden '
                }`}
              >
                <img 
                  src={whatsappIcon} 
                  alt="Whatsapp"
                  className={value !== null ? '' : 'opacity-50'}
                />
              </button>
            </div>;
  }



  if (accessor === 'detalles' || accessor === 'verDetalle' ) {
    const isDownloading = loadingDetailsIds.includes(row.id);

    return <div className="flex items-center justify-center">
            <button 
              onClick={() => handleViewDetails(row.id, value)}
              disabled={isDownloading}
              className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
                {isDownloading ? (
                  <svg className="w-5 h-5 animate-spin text-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : (
                  <img src={details} alt="Detalles" />
                )}
            </button>
          </div>;
  }

  if (accessor === 'descargar') {
    const isDownloading = downloadingIds.includes(row.id);
    const canDownload = row.canDownload !== false;
    return  <div className="flex items-center justify-center">
              <button 
                onClick={() => canDownload && handleDownload(row.id, value)}
                disabled={!canDownload || isDownloading}
                className={`p-2 flex justify-center items-center rounded-[4px] border-[1px] w-[49px] h-[37px]
                ${canDownload 
            ? 'bg-[#EFEEF7] border-[#D9D9D9] hover:bg-blue hover:text-white cursor-pointer' 
            : 'bg-gray-100 border-gray-200 cursor-not-allowed opacity-50'
          }`}

                >
                  {isDownloading ? (
                    <svg className="w-5 h-5 animate-spin text-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  ) : (
                    <img src={download} alt="Descargar"/>
                  )}
              </button>
            </div>;
  }

  if (accessor === 'contactar') {
    return  <div className="flex items-center justify-center">
              <button 
                onClick={() => handleContact(row.areaId)}
                className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.5 10.5C3.89782 10.5 4.27936 10.342 4.56066 10.0607C4.84196 9.77936 5 9.39782 5 9C5 8.60218 4.84196 8.22064 4.56066 7.93934C4.27936 7.65804 3.89782 7.5 3.5 7.5C3.10218 7.5 2.72064 7.65804 2.43934 7.93934C2.15804 8.22064 2 8.60218 2 9C2 9.39782 2.15804 9.77936 2.43934 10.0607C2.72064 10.342 3.10218 10.5 3.5 10.5Z" fill="black" stroke="black" stroke-width="2" stroke-linejoin="round"/>
                  <path d="M16.25 3C16.4489 3 16.6397 2.92098 16.7803 2.78033C16.921 2.63968 17 2.44891 17 2.25C17 2.05109 16.921 1.86032 16.7803 1.71967C16.6397 1.57902 16.4489 1.5 16.25 1.5C16.0511 1.5 15.8603 1.57902 15.7197 1.71967C15.579 1.86032 15.5 2.05109 15.5 2.25C15.5 2.44891 15.579 2.63968 15.7197 2.78033C15.8603 2.92098 16.0511 3 16.25 3ZM16.25 9.75C16.4489 9.75 16.6397 9.67098 16.7803 9.53033C16.921 9.38968 17 9.19891 17 9C17 8.80109 16.921 8.61032 16.7803 8.46967C16.6397 8.32902 16.4489 8.25 16.25 8.25C16.0511 8.25 15.8603 8.32902 15.7197 8.46967C15.579 8.61032 15.5 8.80109 15.5 9C15.5 9.19891 15.579 9.38968 15.7197 9.53033C15.8603 9.67098 16.0511 9.75 16.25 9.75ZM16.25 16.5C16.4489 16.5 16.6397 16.421 16.7803 16.2803C16.921 16.1397 17 15.9489 17 15.75C17 15.5511 16.921 15.3603 16.7803 15.2197C16.6397 15.079 16.4489 15 16.25 15C16.0511 15 15.8603 15.079 15.7197 15.2197C15.579 15.3603 15.5 15.5511 15.5 15.75C15.5 15.9489 15.579 16.1397 15.7197 16.2803C15.8603 16.421 16.0511 16.5 16.25 16.5Z" stroke="black" stroke-width="2" stroke-linejoin="round"/>
                  <path d="M12.5 2.25H8V15.75H12.5M5 9H12.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
            </div>;
  }

  if (accessor === 'eliminar') {
    return  <div className="flex items-center justify-center">
              <button
                onClick={() => value()}
                className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px] hover:bg-red hover:text-white transition-colors">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7008 3.10083L12.945 4.79167H16.25C16.4158 4.79167 16.5747 4.85751 16.6919 4.97472C16.8092 5.09193 16.875 5.25091 16.875 5.41667C16.875 5.58243 16.8092 5.7414 16.6919 5.85861C16.5747 5.97582 16.4158 6.04167 16.25 6.04167H15.6092L14.8817 14.5292C14.8375 15.0458 14.8017 15.4708 14.7442 15.8142C14.6858 16.1717 14.5967 16.4917 14.4225 16.7883C14.149 17.2543 13.7424 17.6278 13.255 17.8608C12.945 18.0083 12.6183 18.0692 12.2567 18.0975C11.9092 18.125 11.4833 18.125 10.965 18.125H9.035C8.51667 18.125 8.09083 18.125 7.74333 18.0975C7.38167 18.0692 7.055 18.0083 6.745 17.8608C6.25757 17.6278 5.85098 17.2543 5.5775 16.7883C5.4025 16.4917 5.315 16.1717 5.25583 15.8142C5.19833 15.47 5.1625 15.0458 5.11833 14.5292L4.39083 6.04167H3.75C3.58424 6.04167 3.42527 5.97582 3.30806 5.85861C3.19085 5.7414 3.125 5.58243 3.125 5.41667C3.125 5.25091 3.19085 5.09193 3.30806 4.97472C3.42527 4.85751 3.58424 4.79167 3.75 4.79167H7.055L7.29917 3.10083L7.30833 3.05C7.46 2.39167 8.025 1.875 8.73333 1.875H11.2667C11.975 1.875 12.54 2.39167 12.6917 3.05L12.7008 3.10083ZM8.3175 4.79167H11.6817L11.4683 3.31167C11.4283 3.1725 11.3267 3.125 11.2658 3.125H8.73417C8.67333 3.125 8.57167 3.1725 8.53167 3.31167L8.3175 4.79167ZM9.375 8.75C9.375 8.58424 9.30915 8.42527 9.19194 8.30806C9.07473 8.19085 8.91576 8.125 8.75 8.125C8.58424 8.125 8.42527 8.19085 8.30806 8.30806C8.19085 8.42527 8.125 8.58424 8.125 8.75V12.9167C8.125 13.0824 8.19085 13.2414 8.30806 13.3586C8.42527 13.4758 8.58424 13.5417 8.75 13.5417C8.91576 13.5417 9.07473 13.4758 9.19194 13.3586C9.30915 13.2414 9.375 13.0824 9.375 12.9167V8.75ZM11.875 8.75C11.875 8.58424 11.8092 8.42527 11.6919 8.30806C11.5747 8.19085 11.4158 8.125 11.25 8.125C11.0842 8.125 10.9253 8.19085 10.8081 8.30806C10.6908 8.42527 10.625 8.58424 10.625 8.75V12.9167C10.625 13.0824 10.6908 13.2414 10.8081 13.3586C10.9253 13.4758 11.0842 13.5417 11.25 13.5417C11.4158 13.5417 11.5747 13.4758 11.6919 13.3586C11.8092 13.2414 11.875 13.0824 11.875 12.9167V8.75Z" fill="black"/>
                </svg>
              </button>
            </div>
  }

  if (accessor === 'editar') {
    return  <div className="flex items-center justify-center">
              <button
                onClick={() => value()}
                className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]  hover:bg-blue hover:text-white transition-colors">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.333 16.048L16.57 3.81004C17.0534 3.34741 17.6988 3.09245 18.3679 3.09976C19.037 3.10707 19.6767 3.37608 20.1499 3.84917C20.6231 4.32226 20.8923 4.96183 20.8998 5.63093C20.9073 6.30003 20.6525 6.94547 20.19 7.42904L7.951 19.667C7.6718 19.9463 7.31619 20.1366 6.929 20.214L3 21L3.786 17.07C3.86345 16.6828 4.05378 16.3272 4.333 16.048Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14.5 6.5L17.5 9.5" stroke="black" stroke-width="2"/>
                  </svg>
              </button>
            </div>
  }

  if (accessor === 'acciones') {
    return (
      <div className="flex flex-col items-center justify-center gap-2">
        {/* Botón Editar */}
        <button
          onClick={() => value.editar()}
          className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[39px] h-[27px] hover:bg-blue hover:text-white transition-colors"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.333 16.048L16.57 3.81004C17.0534 3.34741 17.6988 3.09245 18.3679 3.09976C19.037 3.10707 19.6767 3.37608 20.1499 3.84917C20.6231 4.32226 20.8923 4.96183 20.8998 5.63093C20.9073 6.30003 20.6525 6.94547 20.19 7.42904L7.951 19.667C7.6718 19.9463 7.31619 20.1366 6.929 20.214L3 21L3.786 17.07C3.86345 16.6828 4.05378 16.3272 4.333 16.048Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.5 6.5L17.5 9.5" stroke="currentColor" strokeWidth="2"/>
          </svg>
        </button>

        {/* Botón Eliminar */}
        <button
          onClick={() => value.eliminar()}
          className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[39px] h-[27px] hover:bg-red hover:text-white transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.7008 3.10083L12.945 4.79167H16.25C16.4158 4.79167 16.5747 4.85751 16.6919 4.97472C16.921 5.25091 16.875 5.41667 16.25 6.04167H15.6092L14.8817 14.5292C14.8375 15.0458 14.8017 15.4708 14.7442 15.8142C14.6858 16.1717 14.5967 16.4917 14.4225 16.7883C14.149 17.2543 13.7424 17.6278 13.255 17.8608C12.945 18.0083 12.6183 18.0692 12.2567 18.0975C11.9092 18.125 11.4833 18.125 10.965 18.125H9.035C8.51667 18.125 8.09083 18.125 7.74333 18.0975C7.38167 18.0692 7.055 18.0083 6.745 17.8608C6.25757 17.6278 5.85098 17.2543 5.5775 16.7883C5.4025 16.4917 5.315 16.1717 5.25583 15.8142C5.19833 15.47 5.1625 15.0458 5.11833 14.5292L4.39083 6.04167H3.75C3.58424 6.04167 3.42527 5.97582 3.30806 5.85861C3.19085 5.7414 3.125 5.58243 3.125 5.41667C3.125 5.25091 3.19085 5.09193 3.30806 4.97472C3.42527 4.85751 3.58424 4.79167 3.75 4.79167H7.055L7.29917 3.10083L7.30833 3.05C7.46 2.39167 8.025 1.875 8.73333 1.875H11.2667C11.975 1.875 12.54 2.39167 12.6917 3.05L12.7008 3.10083ZM8.3175 4.79167H11.6817L11.4683 3.31167C11.4283 3.1725 11.3267 3.125 11.2658 3.125H8.73417C8.67333 3.125 8.57167 3.1725 8.53167 3.31167L8.3175 4.79167ZM9.375 8.75C9.375 8.58424 9.30915 8.42527 9.19194 8.30806C9.07473 8.19085 8.91576 8.125 8.75 8.125C8.58424 8.125 8.42527 8.19085 8.30806 8.30806C8.19085 8.42527 8.125 8.58424 8.125 8.75V12.9167C8.125 13.0824 8.19085 13.2414 8.30806 13.3586C8.42527 13.4758 8.58424 13.5417 8.75 13.5417C8.91576 13.5417 9.07473 13.4758 9.19194 13.3586C9.30915 13.2414 9.375 13.0824 9.375 12.9167V8.75ZM11.875 8.75C11.875 8.58424 11.8092 8.42527 11.6919 8.30806C11.5747 8.19085 11.4158 8.125 11.25 8.125C11.0842 8.125 10.9253 8.19085 10.8081 8.30806C10.6908 8.42527 10.625 8.58424 10.625 8.75V12.9167C10.625 13.0824 10.6908 13.2414 10.8081 13.3586C10.9253 13.4758 11.0842 13.5417 11.25 13.5417C11.4158 13.5417 11.5747 13.4758 11.6919 13.3586C11.8092 13.2414 11.875 13.0824 11.875 12.9167V8.75Z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    );
  }

  if (accessor === 'estado' || accessor === 'razon') {
      const color = row.estadoColor || statusColors[value] ;

    return (
      <div className="flex items-center justify-center">
        <p
          className="rounded-[5px] font-rubikmedium flex justify-center items-center leading-none text-[12px] 2xl:text-[13px] px-2 py-2 w-full text-white"
          style={{ backgroundColor: color }}>
            {value}
        </p>
      </div>
    );
  }

if (accessor === 'estadoGeneralServicio' ) {
  const estadosConBackground = [
    'Pendiente de Llenado de ATC',
    'Pendiente de Facturación'
  ];
  
  const haveBackground = estadosConBackground.includes(value);
  const color =  generalStatusColors[value] ;
  
  return (
    <div className="flex items-center justify-center">
      <p
        className={`rounded-[5px] font-rubikmedium flex justify-center items-center leading-none text-[12px] 2xl:text-[13px] px-2 py-2 w-full 
          ${haveBackground ? 'text-white' : 'text-gray-700 border '}`}
        style={haveBackground ? { backgroundColor: color } : { borderColor: color }}>
          {value}
      </p>
    </div>
  );
}

if (accessor === 'estadoSolped' || accessor === 'estadoHes' || accessor === 'estadoOC') {
  const color = liberationStatusColors[value] ;
    return (
      <div className="flex items-center justify-center">
        <p
          className="rounded-[5px] font-rubikmedium flex justify-center items-center leading-none text-[12px] 2xl:text-[13px] px-2 py-2 w-full text-white"
          style={{ backgroundColor: color }}>
            {value}
        </p>
      </div>
    );
}

  if (accessor === 'status') {
    return (
      <div className="flex items-center justify-center">
        <p
          className="rounded-[5px] font-rubikmedium flex justify-center items-center leading-none text-[12px] 2xl:text-[14px] 2xl:w-[90px] 2xl:h-[31px] w-[82px] h-[28px] text-white"
          style={{ backgroundColor: statusColors[value] }}>
            {value}
        </p>
      </div>
    );
  }

  if (accessor === 'mensaje') {
    return (
      <div className="flex items-center justify-center">
        <button className="group p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
          <svg className="fill-black group-hover:fill-blue" width="19" height="14" viewBox="0 0 19 14" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.379 0.879C0.5 1.757 0.5 3.172 0.5 6V8C0.5 10.828 0.5 12.243 1.379 13.121C2.257 14 3.672 14 6.5 14H12.5C15.328 14 16.743 14 17.621 13.121C18.5 12.243 18.5 10.828 18.5 8V6C18.5 3.172 18.5 1.757 17.621 0.879C16.743 1.78814e-07 15.328 0 12.5 0H6.5C3.672 0 2.257 1.78814e-07 1.379 0.879ZM4.055 3.168C3.83434 3.02081 3.56424 2.9673 3.30413 3.01924C3.04402 3.07119 2.8152 3.22434 2.668 3.445C2.52081 3.66566 2.4673 3.93576 2.51924 4.19587C2.57119 4.45598 2.72434 4.6848 2.945 4.832L8.391 8.462C8.71945 8.68085 9.10531 8.79763 9.5 8.79763C9.89469 8.79763 10.2805 8.68085 10.609 8.462L16.055 4.832C16.2757 4.6848 16.4288 4.45598 16.4808 4.19587C16.5327 3.93576 16.4792 3.66566 16.332 3.445C16.1848 3.22434 15.956 3.07119 15.6959 3.01924C15.4358 2.9673 15.1657 3.02081 14.945 3.168L9.5 6.798L4.055 3.168Z"/>
          </svg>
      </button>
      </div>
    );
  }

  if (accessor === 'aceptar') {
    return  <div className="flex items-center justify-center">
              <button
              onClick={() => {
                if (typeof value === 'function') {
                  const { aceptar, rechazar, agendar, detalles, ...appointmentData } = row;
                  value(appointmentData); 
                }
              }}
                className="p-2 flex hover:text-white hover:border-[#43B02A] hover:bg-[#43B02A] justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
                <FaCheck />
              </button>
            </div>;
  }

  if (accessor === 'rechazar') {
    return  <div className="flex items-center justify-center">
              <button 
              onClick={() => {
                if (typeof value === 'function') {
                  const { aceptar, rechazar, agendar, detalles, ...appointmentData } = row;
                  value(appointmentData); 
                }
              }}
                className="flex hover:text-white justify-center items-center bg-[#EFEEF7] hover:bg-[#E44949] hover:border-[#E44949] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
                <RiCloseLargeFill />
              </button>
            </div>;
  }



  if (accessor === 'confirmarCita') {
  const isConfirmed = confirmedPositions.includes(row.positionId || row.id);
  
    return  <div className="flex items-center justify-center">
              <button
              onClick={() => {
                if (typeof value === 'function') {
                  value();
                }
              }}
              className={`flex items-center justify-center transition-colors duration-200 ${
                isConfirmed 
                  ? 'text-[#43B02A] cursor-default' 
                    : 'text-[#D9D9D9] cursor-pointer'
              }`}

              >
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 0C6.286 0 0 6.286 0 14C0 21.714 6.286 28 14 28C21.714 28 28 21.714 28 14C28 6.286 21.714 0 14 0ZM20.692 10.78L12.754 18.718C12.558 18.914 12.292 19.026 12.012 19.026C11.732 19.026 11.466 18.914 11.27 18.718L7.308 14.756C6.902 14.35 6.902 13.678 7.308 13.272C7.714 12.866 8.386 12.866 8.792 13.272L12.012 16.492L19.208 9.296C19.614 8.89 20.286 8.89 20.692 9.296C21.098 9.702 21.098 10.36 20.692 10.78Z"
                   fill="currentColor"/>
                  </svg>
              </button>
            </div>;
  }

if (accessor === 'rechazarCita') {
  const isRefused = refusedPositions.includes(row.positionId || row.id);

  return (
    <div className="flex items-center justify-center">
      <button 
        onClick={() => {
          if (typeof value === 'function') {
            value();
          }
        }}
        className={`flex items-center justify-center transition-colors duration-200 ${
          isRefused 
            ? 'text-[#E44949] cursor-default' 
              : 'text-[#D9D9D9] cursor-pointer'
        }`}
      >
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 0C6.286 0 0 6.286 0 14C0 21.714 6.286 28 14 28C21.714 28 28 21.714 28 14C28 6.286 21.714 0 14 0ZM18.704 17.22C19.11 17.626 19.11 18.298 18.704 18.704C18.494 18.914 18.228 19.012 17.962 19.012C17.696 19.012 17.43 18.914 17.22 18.704L14 15.484L10.78 18.704C10.57 18.914 10.304 19.012 10.038 19.012C9.772 19.012 9.506 18.914 9.296 18.704C8.89 18.298 8.89 17.626 9.296 17.22L12.516 14L9.296 10.78C8.89 10.374 8.89 9.702 9.296 9.296C9.702 8.89 10.374 8.89 10.78 9.296L14 12.516L17.22 9.296C17.626 8.89 18.298 8.89 18.704 9.296C19.11 9.702 19.11 10.374 18.704 10.78L15.484 14L18.704 17.22Z" 
                fill="currentColor"/>
        </svg>
      </button>
    </div>
  );
}


  if (accessor === 'dias') {
    return (
      <div className="flex items-center justify-center">
        <p
          className=" font-itcmedium flex justify-center items-center text-[14px] w-[30px] h-[30px] text-white"
          style={{ backgroundColor: statusColors[row.daysType] }}>
            {value}
        </p>
      </div>
    );
  }

  if (accessor === 'ir') {
    return (
      <div className="flex items-center justify-center">
        <button
          onClick={() => value()}
          className="group p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
          <svg className="fill-black group-hover:fill-blue" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.4375 9C17.4375 4.34025 13.6598 0.562501 9 0.5625C4.34025 0.5625 0.562501 4.34025 0.5625 9C0.5625 13.6598 4.34025 17.4375 9 17.4375C13.6598 17.4375 17.4375 13.6598 17.4375 9ZM9.47672 10.4465L4.21875 10.4465L4.21875 7.55353L9.47672 7.55353L9.47672 4.5L13.7813 9L9.47672 13.5L9.47672 10.4465Z" />
          </svg>
      </button>
      </div>
    );
  }

  if (accessor === 'corregir' || accessor === 'agregarOb') {
    return (
      <div className="flex items-center justify-center">
        <button
          onClick={() => value()} 
          className="group p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
          <svg className="fill-black group-hover:fill-blue" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0497 1.6875C13.5499 1.6875 14.0517 1.76925 14.4019 2.13225C14.7469 2.49075 14.8122 2.98725 14.8122 3.45V12.3C14.8122 12.7072 14.7582 13.1077 14.5497 13.4318C14.4294 13.6186 14.261 13.7697 14.0622 13.869V14.55C14.0622 15.0495 13.9812 15.5512 13.6189 15.9015C13.2604 16.248 12.7639 16.3125 12.3012 16.3125H4.31218C4.01382 16.3125 3.72767 16.194 3.51669 15.983C3.30571 15.772 3.18718 15.4859 3.18718 15.1875V4.51275C3.18493 4.13925 3.18268 3.67275 3.28468 3.2475C3.40993 2.7285 3.69868 2.22525 4.31293 1.9125C4.56643 1.7835 4.83343 1.7325 5.11843 1.71C5.39218 1.6875 5.72593 1.6875 6.12718 1.6875H13.0497ZM12.3012 15.1875C12.7114 15.1875 12.8134 15.1155 12.8367 15.093C12.8554 15.075 12.9372 14.9767 12.9372 14.55V14.0625H5.43718C5.13882 14.0625 4.85267 14.181 4.64169 14.392C4.43071 14.603 4.31218 14.8891 4.31218 15.1875H12.3012ZM11.1387 6.33C11.182 6.27017 11.2131 6.20238 11.2303 6.13052C11.2474 6.05866 11.2502 5.98412 11.2386 5.91117C11.2269 5.83822 11.201 5.76828 11.1623 5.70534C11.1236 5.64241 11.0729 5.58771 11.0131 5.54437C10.9532 5.50104 10.8854 5.46991 10.8136 5.45277C10.7417 5.43563 10.6672 5.43281 10.5942 5.44448C10.5213 5.45614 10.4513 5.48206 10.3884 5.52076C10.3255 5.55945 10.2708 5.61017 10.2274 5.67L8.37643 8.23275L7.62268 7.37175C7.52345 7.26337 7.38575 7.19813 7.23903 7.18998C7.09231 7.18183 6.94823 7.23141 6.8376 7.32813C6.72697 7.42484 6.65858 7.56101 6.64706 7.7075C6.63553 7.85399 6.68179 7.99918 6.77593 8.112L7.81093 9.294C8.14318 9.67425 8.74394 9.6465 9.03943 9.23625L11.1387 6.33Z" />
          </svg>
      </button>
      </div>
    );
  }

  if (accessor === 'agendar' ) {
    return (
      <div className="flex items-center justify-center">
        <button
          onClick={() => {
            if (typeof value === 'function') {
              value(); 
            }
          }} 
          className="group p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
          <svg className='fill-black group-hover:fill-blue' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 11H9V13H7V11ZM7 15H9V17H7V15ZM11 11H13V13H11V11ZM11 15H13V17H11V15ZM15 11H17V13H15V11ZM15 15H17V17H15V15Z" />
          <path d="M5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22ZM19 8L19.001 20H5V8H19Z" />
          </svg>
      </button>
      </div>
    );
  }

  if (accessor === 'entrego' ) {  
  const isProcessing = row.processing;
  const isDelivered = row.delivered === true;
  const isUndelivered = row.delivered === false;

    return (
      <div className="flex items-center justify-center">
        <button
          onClick={() => {
            if (!isProcessing) value();
          }}
          className={`p-2 flex justify-center items-center transition-colors rounded-[4px] border-[1px] w-[49px] h-[37px] ${
            isDelivered 
              ? 'bg-green border-green text-white hover:bg-[#3a9e25] hover:border-[#3a9e25]' 
              : isUndelivered
                ? 'bg-[#EFEEF7] border-[#D9D9D9] hover:bg-[#e0e0e0]'
                : 'bg-[#EFEEF7] border-[#D9D9D9] hover:bg-[#e0e0e0]'
          }`}
          disabled={ isProcessing}
          title={isDelivered ? "Ya entregado" : "Marcar como entregado"}
        >
        {isProcessing ? (
          <svg className="w-5 h-5 animate-spin text-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.94956 14.3828C5.85037 14.1458 4.83537 13.617 4.01134 12.852C3.18731 12.087 2.58471 11.1141 2.26692 10.0356C1.94914 8.95718 1.92792 7.81301 2.20551 6.7235C2.48309 5.63399 3.04921 4.63942 3.84431 3.84442C4.63942 3.04941 5.63411 2.48336 6.72376 2.20582C7.8134 1.92827 8.95772 1.94948 10.0363 2.26723C11.1149 2.58497 12.088 3.1875 12.853 4.01142C13.6181 4.83535 14.147 5.85022 14.384 6.94927C14.4249 7.14016 14.54 7.30699 14.7039 7.41304C14.8678 7.5191 15.0672 7.5557 15.2581 7.5148C15.449 7.47389 15.6159 7.35883 15.7219 7.19492C15.828 7.03102 15.8646 6.83169 15.8237 6.6408C15.5313 5.28291 14.8782 4.02894 13.9332 3.01083C12.9882 1.99272 11.7862 1.24812 10.4537 0.855375C9.12119 0.462627 7.70745 0.436257 6.36123 0.779039C5.01501 1.12182 3.78608 1.82108 2.80376 2.80324C1.82143 3.7854 1.12203 5.01414 0.77915 6.36018C0.436268 7.70621 0.462581 9.11977 0.855321 10.4521C1.24806 11.7845 1.99271 12.9863 3.0109 13.9313C4.0291 14.8762 5.2832 15.5292 6.64125 15.8217C6.73625 15.8433 6.8346 15.8459 6.93059 15.8292C7.02658 15.8125 7.11831 15.7769 7.20044 15.7245C7.28257 15.6721 7.35348 15.6039 7.40905 15.5239C7.46462 15.4439 7.50375 15.3536 7.52416 15.2583C7.54457 15.1631 7.54586 15.0647 7.52795 14.969C7.51005 14.8732 7.4733 14.7819 7.41985 14.7005C7.3664 14.619 7.2973 14.549 7.21657 14.4945C7.13584 14.4399 7.04508 14.402 6.94956 14.3828Z" 
          fill={isDelivered ? "white" : "black"}/>
          <path d="M7.55969 3.80256V7.51506H5.39969C5.20873 7.51506 5.0256 7.59329 4.89057 7.73253C4.75554 7.87178 4.67969 8.06064 4.67969 8.25756C4.67969 8.45448 4.75554 8.64334 4.89057 8.78259C5.0256 8.92183 5.20873 9.00006 5.39969 9.00006H8.27969C8.47064 9.00006 8.65378 8.92183 8.7888 8.78259C8.92383 8.64334 8.99969 8.45448 8.99969 8.25756V3.80256C8.99969 3.60564 8.92383 3.41678 8.7888 3.27753C8.65378 3.13829 8.47064 3.06006 8.27969 3.06006C8.08873 3.06006 7.9056 3.13829 7.77057 3.27753C7.63554 3.41678 7.55969 3.60564 7.55969 3.80256Z"
          fill={isDelivered ? "white" : "black"}/>
          <path d="M12.6899 7.91992C11.7465 7.91992 10.8243 8.19968 10.0399 8.72381C9.25543 9.24795 8.64405 9.99292 8.28302 10.8645C7.92199 11.7361 7.82753 12.6952 8.01158 13.6205C8.19563 14.5458 8.64993 15.3957 9.31702 16.0628C9.98412 16.7299 10.8341 17.1842 11.7593 17.3683C12.6846 17.5523 13.6437 17.4579 14.5153 17.0968C15.3869 16.7358 16.1319 16.1244 16.656 15.34C17.1802 14.5556 17.4599 13.6333 17.4599 12.6899C17.4586 11.4252 16.9557 10.2127 16.0614 9.31845C15.1671 8.42419 13.9546 7.92122 12.6899 7.91992ZM12.6899 15.9922C12.0368 15.9922 11.3983 15.7986 10.8553 15.4357C10.3122 15.0728 9.88893 14.5571 9.63899 13.9537C9.38905 13.3502 9.32365 12.6863 9.45107 12.0457C9.57849 11.4051 9.893 10.8167 10.3548 10.3548C10.8167 9.893 11.4051 9.57849 12.0457 9.45107C12.6863 9.32365 13.3502 9.38904 13.9537 9.63899C14.5571 9.88893 15.0728 10.3122 15.4357 10.8553C15.7986 11.3983 15.9922 12.0368 15.9922 12.6899C15.9912 13.5654 15.6429 14.4048 15.0239 15.0239C14.4048 15.6429 13.5654 15.9912 12.6899 15.9922Z" 
          fill={isDelivered ? "white" : "black"}/>
          <path d="M14.457 11.0098C14.6075 11.0098 14.7535 11.067 14.8623 11.1699C14.9711 11.2732 15.0341 11.4149 15.0342 11.5645C15.0342 11.7142 14.9713 11.8566 14.8623 11.96L12.2969 14.3896C12.1881 14.4926 12.0421 14.5498 11.8916 14.5498C11.7412 14.5497 11.5951 14.4925 11.4863 14.3896L10.6318 13.5801L10.6279 13.5762C10.525 13.4715 10.467 13.331 10.4697 13.1846C10.4726 13.0383 10.5361 12.9007 10.6426 12.7998C10.7488 12.6992 10.8902 12.6422 11.0371 12.6396C11.1473 12.6378 11.2561 12.6665 11.3496 12.7217L11.4385 12.7861L11.4424 12.79L11.8916 13.2158L14.0518 11.1699L14.1396 11.1016C14.2337 11.0421 14.3441 11.0098 14.457 11.0098Z" 
          fill={isDelivered ? "white" : "black"} stroke={isDelivered ? "white" : "black"} stroke-width="0.3"/>
          </svg>
        )}
      </button>
      </div>
    );
  }

  if (accessor === 'noEntrego' ) {
  const isProcessing = row.processing;
  const isDelivered = row.delivered === true;
  const isUndelivered = row.delivered === false;

    return (
      <div className="flex items-center justify-center">
        <button
          onClick={() => {
            if (!isProcessing) value();
          }}          className={`p-2 flex justify-center items-center transition-colors rounded-[4px] border-[1px] w-[49px] h-[37px] ${
            isUndelivered 
              ? 'bg-[#CA2D00] border-[#CA2D00] text-white hover:bg-[#b32800] hover:border-[#b32800]' 
              : isDelivered
                ? 'bg-[#EFEEF7] border-[#D9D9D9] hover:bg-[#e0e0e0]'
                : 'bg-[#EFEEF7] border-[#D9D9D9] hover:bg-[#e0e0e0]'
          }`}
          disabled={ isProcessing}
          title={isUndelivered ? "No entregado" : "Marcar como no entregado"}
        >

        {isProcessing ? (
          <svg className="w-5 h-5 animate-spin text-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        ) : (

        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.94956 14.3828C5.85037 14.1458 4.83537 13.617 4.01134 12.852C3.18731 12.087 2.58471 11.1141 2.26692 10.0356C1.94914 8.95718 1.92792 7.81301 2.20551 6.7235C2.48309 5.63399 3.04921 4.63942 3.84431 3.84442C4.63942 3.04941 5.63411 2.48336 6.72376 2.20582C7.8134 1.92827 8.95772 1.94948 10.0363 2.26723C11.1149 2.58497 12.088 3.1875 12.853 4.01142C13.6181 4.83535 14.147 5.85022 14.384 6.94927C14.4249 7.14016 14.54 7.30699 14.7039 7.41304C14.8678 7.5191 15.0672 7.5557 15.2581 7.5148C15.449 7.47389 15.6159 7.35883 15.7219 7.19492C15.828 7.03102 15.8646 6.83169 15.8237 6.6408C15.5313 5.28291 14.8782 4.02894 13.9332 3.01083C12.9882 1.99272 11.7862 1.24812 10.4537 0.855375C9.12119 0.462627 7.70745 0.436257 6.36123 0.779039C5.01501 1.12182 3.78608 1.82108 2.80376 2.80324C1.82143 3.7854 1.12203 5.01414 0.77915 6.36018C0.436268 7.70621 0.462581 9.11977 0.855321 10.4521C1.24806 11.7845 1.99271 12.9863 3.0109 13.9313C4.0291 14.8762 5.2832 15.5292 6.64125 15.8217C6.73625 15.8433 6.8346 15.8459 6.93059 15.8292C7.02658 15.8125 7.11831 15.7769 7.20044 15.7245C7.28257 15.6721 7.35348 15.6039 7.40905 15.5239C7.46462 15.4439 7.50375 15.3536 7.52416 15.2583C7.54457 15.1631 7.54586 15.0647 7.52795 14.969C7.51005 14.8732 7.4733 14.7819 7.41985 14.7005C7.3664 14.619 7.2973 14.549 7.21657 14.4945C7.13584 14.4399 7.04508 14.402 6.94956 14.3828Z"
           fill={isUndelivered ? "white" : "#CA2D00"}/>
          <path d="M7.55969 3.80256V7.51506H5.39969C5.20873 7.51506 5.0256 7.59329 4.89057 7.73253C4.75554 7.87178 4.67969 8.06064 4.67969 8.25756C4.67969 8.45448 4.75554 8.64334 4.89057 8.78259C5.0256 8.92183 5.20873 9.00006 5.39969 9.00006H8.27969C8.47064 9.00006 8.65378 8.92183 8.7888 8.78259C8.92383 8.64334 8.99969 8.45448 8.99969 8.25756V3.80256C8.99969 3.60564 8.92383 3.41678 8.7888 3.27753C8.65378 3.13829 8.47064 3.06006 8.27969 3.06006C8.08873 3.06006 7.9056 3.13829 7.77057 3.27753C7.63554 3.41678 7.55969 3.60564 7.55969 3.80256Z" 
           fill={isUndelivered ? "white" : "#CA2D00"}/>
          <path d="M12.6899 7.91992C11.7465 7.91992 10.8243 8.19968 10.0399 8.72381C9.25543 9.24795 8.64405 9.99292 8.28302 10.8645C7.92199 11.7361 7.82753 12.6952 8.01158 13.6205C8.19563 14.5458 8.64993 15.3957 9.31702 16.0628C9.98412 16.7299 10.8341 17.1842 11.7593 17.3683C12.6846 17.5523 13.6437 17.4579 14.5153 17.0968C15.3869 16.7358 16.1319 16.1244 16.656 15.34C17.1802 14.5556 17.4599 13.6333 17.4599 12.6899C17.4586 11.4252 16.9557 10.2127 16.0614 9.31845C15.1671 8.42419 13.9546 7.92122 12.6899 7.91992ZM12.6899 15.9922C12.0368 15.9922 11.3983 15.7986 10.8553 15.4357C10.3122 15.0728 9.88893 14.5571 9.63899 13.9537C9.38905 13.3502 9.32365 12.6863 9.45107 12.0457C9.57849 11.4051 9.893 10.8167 10.3548 10.3548C10.8167 9.893 11.4051 9.57849 12.0457 9.45107C12.6863 9.32365 13.3502 9.38904 13.9537 9.63899C14.5571 9.88893 15.0728 10.3122 15.4357 10.8553C15.7986 11.3983 15.9922 12.0368 15.9922 12.6899C15.9912 13.5654 15.6429 14.4048 15.0239 15.0239C14.4048 15.6429 13.5654 15.9912 12.6899 15.9922Z"
           fill={isUndelivered ? "white" : "#CA2D00"}/>
          <path d="M12.7796 10.0801C12.5886 10.0801 12.4055 10.1601 12.2705 10.3027C12.1354 10.4452 12.0596 10.6385 12.0596 10.8401V12.7401C12.0596 12.9416 12.1354 13.135 12.2705 13.2775C12.4055 13.42 12.5886 13.5001 12.7796 13.5001C12.9705 13.5001 13.1537 13.42 13.2887 13.2775C13.4237 13.135 13.4996 12.9416 13.4996 12.7401V10.8401C13.4996 10.6385 13.4237 10.4452 13.2887 10.3027C13.1537 10.1601 12.9705 10.0801 12.7796 10.0801Z"
           fill={isUndelivered ? "white" : "#CA2D00"}/>
          <path d="M12.7796 15.3004C13.1772 15.3004 13.4996 14.978 13.4996 14.5804C13.4996 14.1827 13.1772 13.8604 12.7796 13.8604C12.3819 13.8604 12.0596 14.1827 12.0596 14.5804C12.0596 14.978 12.3819 15.3004 12.7796 15.3004Z"
           fill={isUndelivered ? "white" : "#CA2D00"}/>
          </svg>
        )}
      </button>
      </div>
    );
  }

  return value;
};
export default DynamicTable;